/**
 * SPA-specific OAuth configuration.
 *
 * Redirect URI is derived dynamically from the current origin + /callback.
 * The backend's OAuthClients config must include this URI in its allowed list.
 */

export function getSpaOAuthConfig() {
  return {
    clientId: 'iap-web-app',
    scope: 'openid profile email offline_access',
    redirectUri: new URL('/callback', window.location.origin).toString()
  };
}